import React, {Component} from "react";
import FormField from "../../../components/form/FormField";
import SignatureInput from "../../../components/signature-input/SignatureInput";
import TextInput from "../../../components/text-input/TextInput";
import moment from "moment";
import FormLanguages from "../enum/FormLanguages";
import {isMinor} from "../../patient/Patient";
import SignatureDisplay from "../../../components/signature-input/SignatureDisplay";
import PsychologyFormTextEnum from "../enum/PsychologyFormTextEnum";

export default class PublicPsychologyWizardPage extends Component {

    /**
     * Handle field changes with proper form name reference
     * @param {string} fieldName - Name of the field to update
     * @param {*} value - New value for the field
     */
    handleFieldChange = (fieldName, value) => {
        const { fieldChanged } = this.props;

        if (fieldChanged) {
            fieldChanged('psychologyConsentForm', fieldName, value);
        }
    }

    /**
     * Get localized text based on the current language
     * @param {string} key - The key to look up in the text enum
     * @returns {string} - The localized text
     */
    getLocalizedText = (key) => {
        const { language } = this.props;
        const selectedLanguage = language || FormLanguages.ENGLISH.name;
        return PsychologyFormTextEnum[key] ? PsychologyFormTextEnum[key][selectedLanguage] : '';
    }

    render() {
        const {
            form,
            formBodyClass = '',
            formFields,
            patientName,
            patientDOB,
            enumLabel
        } = this.props;

        const isPatientMinor = isMinor(patientDOB, 'KUWAIT');

        return (
            <div className={formBodyClass + ' m-4'}>
                <h3 className={'text-center mb-4'}>
                    {this.getLocalizedText('Form_Title')}
                </h3>

                <p>
                    {this.getLocalizedText('Treatment_Consideration')}
                </p>

                <p>{this.getLocalizedText('Understanding')}<br />
                    <ul>
                        <li>
                            <p>
                                {this.getLocalizedText('Understanding_Point1')}
                            </p>
                        </li>
                        <li>
                            <p>
                                {this.getLocalizedText('Understanding_Point2')}
                            </p>
                        </li>
                        <li>
                            <p>
                                {this.getLocalizedText('Understanding_Point3')}
                            </p>
                        </li>
                        <li>
                            <p>
                                {this.getLocalizedText('Understanding_Point4')}
                                <ul>
                                    <li>
                                        <p>
                                            {this.getLocalizedText('Understanding_Point4_1')}
                                        </p>
                                    </li>
                                    <li>
                                        <p>
                                            {this.getLocalizedText('Understanding_Point4_2')}
                                        </p>
                                    </li>
                                    <li>
                                        <p>
                                            {this.getLocalizedText('Understanding_Point4_3')}
                                        </p>
                                    </li>
                                    <li>
                                        <p>
                                            {this.getLocalizedText('Understanding_Point4_4')}
                                        </p>
                                    </li>
                                </ul>
                            </p>
                        </li>
                        <li>
                            <p>
                                {this.getLocalizedText('Understanding_Point5')}
                            </p>
                        </li>
                        <li>
                            <p>
                                {this.getLocalizedText('Understanding_Point6')}
                            </p>
                        </li>
                        <li>
                            <p>
                                {this.getLocalizedText('Understanding_Point7')}
                            </p>
                        </li>
                        <li>
                            <p>
                                {this.getLocalizedText('Understanding_Point8')}
                            </p>
                        </li>
                        <li>
                            <p>
                                {this.getLocalizedText('Understanding_Point9')}
                            </p>
                        </li>
                        <li>
                            <p>
                                {this.getLocalizedText('Understanding_Point10')}
                            </p>
                        </li>
                        <li>
                            <p>
                                {this.getLocalizedText('Understanding_Point11')}
                            </p>
                        </li>
                        <li>
                            <p>
                                {this.getLocalizedText('Understanding_Point12')}
                            </p>
                        </li>
                        <li>
                            <p>
                                {this.getLocalizedText('Understanding_Point13')}
                            </p>
                        </li>
                    </ul>
                </p>

                <p><b>{this.getLocalizedText('Psychology_Data_Collection_Header')}</b><br />
                </p>
                <p>{this.getLocalizedText('Psychology_Data_Collection_Information')}<br />
                </p>
                <p>{this.getLocalizedText('Psychology_Data_Collection_Purpose')}<br />
                </p>
                <p>{this.getLocalizedText('Psychology_Data_Protection_Header')}<br />
                    <ul>
                        <li>
                            <p>
                                {this.getLocalizedText('Psychology_Data_Protection_Point1')}
                            </p>
                        </li>
                        <li>
                            <p>
                                {this.getLocalizedText('Psychology_Data_Protection_Point2')}
                            </p>
                        </li>
                        <li>
                            <p>
                                {this.getLocalizedText('Psychology_Data_Protection_Point3')}
                            </p>
                        </li>
                        <li>
                            <p>
                                {this.getLocalizedText('Psychology_Data_Protection_Point4')}
                            </p>
                        </li>
                        <li>
                            <p>
                                {this.getLocalizedText('Psychology_Data_Protection_Point5')}
                            </p>
                        </li>
                        <li>
                            <p>
                                {this.getLocalizedText('Psychology_Data_Protection_Point6')}
                            </p>
                        </li>
                    </ul>
                </p>
                <p>{this.getLocalizedText('Psychology_Data_Sharing')}<br />
                </p>
                <p>{this.getLocalizedText('Psychology_Marketing')}<br />
                </p>

                <p>{this.getLocalizedText('Psychology_Patient_Rights_Header')}<br />
                    <ul>
                        <li>
                            <p>
                                {this.getLocalizedText('Psychology_Patient_Rights_Point1')}
                            </p>
                        </li>
                        <li>
                            <p>
                                {this.getLocalizedText('Psychology_Patient_Rights_Point2')}
                            </p>
                        </li>
                        <li>
                            <p>
                                {this.getLocalizedText('Psychology_Patient_Rights_Point3')}
                            </p>
                        </li>
                        <li>
                            <p>
                                {this.getLocalizedText('Psychology_Patient_Rights_Point4')}
                            </p>
                        </li>
                        <li>
                            <p>
                                {this.getLocalizedText('Psychology_Patient_Rights_Point5')}
                            </p>
                        </li>
                        <li>
                            <p>
                                {this.getLocalizedText('Psychology_Patient_Rights_Point6')}
                            </p>
                        </li>
                    </ul>
                </p>
                <p><b>{this.getLocalizedText('Psychology_Questions_Concerns')}</b><br />
                    {this.getLocalizedText('Psychology_Questions_Concerns_Description')}
                </p>
                <p><b>{this.getLocalizedText('Psychology_Complaints_Header')}</b><br />
                    {this.getLocalizedText('Psychology_Complaints_Description')}<br />
                    {this.getLocalizedText('Psychology_Complaints_DHA')}<br />
                </p>

                <p><b>{this.getLocalizedText('Psychology_Patient_Responsibility')}</b>
                </p>
                <p><b>{this.getLocalizedText('Psychology_Final_Acknowledgment')}</b>
                </p>
                <p><b>{this.getLocalizedText('Psychology_Data_Understanding')}</b>
                </p>

                <div className="container">
                    <div className="row">
                        <div className="col-md-3 dim14-form-label">
                            {this.getLocalizedText('Date')}
                        </div>
                        <div className="col-md-3 dim14-base-input">
                            {moment(new Date(form.patientDate)).format('MMMM DD, YYYY')}
                        </div>
                    </div>

                    <div className="row">
                        <div className="col-md-3 dim14-form-label">
                            {this.getLocalizedText('Patient_Name')}
                        </div>
                        <div className="col-md-3 dim14-base-input">
                            {patientName}
                        </div>
                        <div className="col-md-3 dim14-form-label">
                            {this.getLocalizedText('Provider_Name')}
                        </div>
                        <div className="col-md-3 dim14-base-input">
                            <FormField ref={formField => formFields.push(formField)} validateOn={form.providerName}
                                required requiredMessage={this.getLocalizedText('Field_Required')}>
                                <TextInput value={form.providerName} disabled />
                            </FormField>
                        </div>
                    </div>

                    <div className="row">
                        <div className="col-md-3 dim14-form-label">
                            {this.getLocalizedText('Print_Name')}
                        </div>
                        <div className="col-md-3 dim14-base-input">
                            <FormField ref={formField => formFields.push(formField)}
                                disabled={!isPatientMinor}
                                required requiredMessage={this.getLocalizedText('Field_Required')}
                                validateOn={form.guardianName}>
                                <TextInput value={form.guardianName} alphabeticOnly
                                    onChange={(value) => this.handleFieldChange('guardianName', value)} />
                            </FormField>
                        </div>
                    </div>

                    <div className="row">
                        <div className="col-md-3 dim14-form-label">
                            {this.getLocalizedText('Relationship_To_Patient')}
                        </div>
                        <div className="col-md-3 dim14-base-input">
                            <FormField ref={formField => formFields.push(formField)}
                                disabled={!isPatientMinor}
                                required requiredMessage={this.getLocalizedText('Field_Required')}
                                validateOn={form.guardianRelationship}>
                                <TextInput value={form.guardianRelationship} alphabeticOnly
                                    onChange={(value) => this.handleFieldChange('guardianRelationship', value)} />
                            </FormField>
                        </div>
                    </div>

                    <div className="row">
                        <div className="col-md-6 dim14-form-label">
                            {this.getLocalizedText('Patient_Signature')}
                        </div>
                        <div className="col-md-6 dim14-form-label">
                            {this.getLocalizedText('Provider_Signature')}
                        </div>
                    </div>

                    <div className="row">
                        <div className="col-md-6">
                            <FormField ref={formField => formFields.push(formField)}
                                required requiredMessage={this.getLocalizedText('Signature_Required')}
                                validateOn={form.patientSignature}>
                                <SignatureInput signature={form.patientSignature}
                                    onClear={() => this.handleFieldChange('patientSignature', null)}
                                    onSave={(signature) => this.handleFieldChange('patientSignature', signature)} />
                            </FormField>
                        </div>
                        <div className="col-md-6">
                            <FormField ref={formField => formFields.push(formField)} validateOn={form.providerSignature}
                                required requiredMessage={this.getLocalizedText('Signature_Required')}>
                                <SignatureDisplay signature={form.providerSignature} />
                            </FormField>
                        </div>
                    </div>
                </div>

                <p className="font-weight-bold">
                    <u>{this.getLocalizedText('Official_Use_Only')}</u></p>
                <p className="font-weight-bold">
                    {this.getLocalizedText('Witness_Statement_Header')}</p>
                <p><i>{this.getLocalizedText('Witness_Statement')}</i></p>

                <div style={{ border: "1px solid", borderRadius: "5px", padding: "30px" }}>
                    <div className="container">
                        <div className="row">
                            <div className="col-md-6 dim14-form-label">
                                {this.getLocalizedText('Witness_Name')}
                            </div>
                            <div className="col-md-6 dim14-base-input">
                                <TextInput value={form.witnessName} alphabeticOnly
                                    onChange={(value) => this.handleFieldChange('witnessName', value)} />
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-md-6">{this.getLocalizedText('Witness_Signature')}</div>
                            <div className="col-md-6">
                                <SignatureInput signature={form.witnessSignature}
                                    onClear={() => this.handleFieldChange('witnessSignature', null)}
                                    onSave={(signature) => this.handleFieldChange('witnessSignature', signature)} />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
} 